import { CommonModule } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { TypographyFontFamily, TypographyFontSize } from '@design-system/components/atoms/typography/entities/typography.types';
import {
  NotificationShowInfo, NotificationSize
} from '@design-system/components/molecules/notification/entities/notification.types';
import { Icon, IconFillColor } from '@design-system/components/atoms/icon/entities/icon.types';
import { TypographyDsComponent } from '@design-system/components/atoms/typography/typography.component';
import { IconDsComponent } from '@design-system/components/atoms/icon/icon.component';

@Component({
  selector: 'app-ds-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TypographyDsComponent,
    IconDsComponent,
  ]
})
export class NotificationDsComponent {

  @Input() size = NotificationSize.RG;
  @Input() notifications = 0;
  @Input() show: NotificationShowInfo = 'number';

  public readonly fontFamily = TypographyFontFamily.SemiBold;
  public readonly iconNotification = Icon.Notification;
  public readonly iconColor = IconFillColor.Light;

  constructor() { }

  get hasNotifications(): boolean {
    return !!this.notifications;
  }

  get enabledContent(): boolean {
    return this.show !== 'none';
  }

  get showNumberOfNotifications(): boolean {
    return this.show === 'number' && this.hasNotifications;
  }

  get showNotificationsIcon(): boolean {
    return this.show === 'icon' && this.hasNotifications;
  }

  get numberFontSize(): string {
    return this.size === NotificationSize.RG ? TypographyFontSize.XXS :
      this.size === NotificationSize.LG ? TypographyFontSize.SM : TypographyFontSize.Minor;
  }

  get iconSize(): number {
    return this.size === NotificationSize.RG ? 16 : this.size === NotificationSize.LG ? 26 : 10;
  }

}
